import api from '../../api';

const path = `/base`;

export const getArchiveListRequest = params =>
    api.get(`${path}/${params.type}/archive/get`, { params });

export const getBasePoliceListRequest = params =>
    api.get(`${path}/police/get`, {
        params,
    });
